/* Case Planet — multi-brand picker: Brand + Model dropdowns and a model search with suggestions.
   Works on top of the theme's picker (caseplanet.js) by driving its brand/model selects. */
(() => {
  'use strict';
  if (window.__cpSearch) return;
  window.__cpSearch = true;

  const norm = s => String(s || '').toLowerCase().replace(/\+/g, ' plus ').replace(/[^a-z0-9]+/g, ' ').trim();
  const mk = (val, label, disabled) => {
    const o = document.createElement('option');
    o.value = val; o.textContent = label; if (disabled) o.disabled = true;
    return o;
  };

  function setup(form) {
    if (form.dataset.cpSearchReady) return;
    const dataEl = form.querySelector('[data-cp-variants]');
    if (!dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const names = (data.options || []).map(o => String(o).toLowerCase());
    const bi = names.indexOf(String(data.brandOption).toLowerCase());
    if (bi < 0 || names.length < 2) return;
    const mi = bi === 0 ? 1 : 0;
    form.dataset.cpSearchReady = '1';

    const V = data.variants || [];
    const brandSel = form.querySelector('[data-cp-brand]');
    const modelSel = form.querySelector('[data-cp-model]');
    const brands = [...new Set(V.map(v => v.opts[bi]))];

    // Every brand in the Brand dropdown (the base picker only lists iPhone).
    if (brandSel) {
      brandSel.replaceChildren(mk('', 'Select brand'), ...brands.map(b => mk(b, b)));
      brandSel.value = '';
      brandSel.disabled = false;
    }

    // Safety net: whenever a brand is showing, the Model dropdown must hold that brand's models.
    // (Covers the browser restoring an old choice on reload/back without firing a change event.)
    const ensureModels = () => {
      if (!brandSel || !modelSel) return;
      const b = brandSel.value;
      if (!b) {
        if (!modelSel.disabled) {
          modelSel.replaceChildren(mk('', 'Select brand first'));
          modelSel.disabled = true;
        }
        return;
      }
      const list = V.filter(v => v.opts[bi] === b);
      const ids = new Set(list.map(v => String(v.id)));
      const current = Array.from(modelSel.options).filter(o => o.value).map(o => o.value);
      const ok = !modelSel.disabled && current.length === list.length && current.every(id => ids.has(id));
      if (ok) return;
      const keep = ids.has(modelSel.value) ? modelSel.value : '';
      modelSel.replaceChildren(
        mk('', 'Select model'),
        ...list.map(v => mk(String(v.id), v.available ? v.opts[mi] : `${v.opts[mi]} (sold out)`, !v.available))
      );
      modelSel.disabled = false;
      modelSel.value = keep;
    };
    brandSel && brandSel.addEventListener('change', () => setTimeout(ensureModels, 0));
    window.addEventListener('pageshow', () => setTimeout(ensureModels, 60));
    window.addEventListener('load', () => setTimeout(ensureModels, 60));
    setTimeout(ensureModels, 300);

    const index = V.map(v => {
      const b = v.opts[bi], m = v.opts[mi], h = norm(b + ' ' + m);
      return { v, b, m, h, c: h.replace(/ /g, ''), mn: norm(m) };
    });

    const choose = r => {
      if (!r) return;
      if (brandSel) { brandSel.value = r.b; brandSel.dispatchEvent(new Event('change', { bubbles: true })); }
      ensureModels();
      if (modelSel) { modelSel.value = String(r.v.id); modelSel.dispatchEvent(new Event('change', { bubbles: true })); }
    };

    // Keep a ?variant= link working for any brand.
    if (data.selected) {
      const r = index.find(x => x.v.id === data.selected);
      if (r) choose(r);
    }

    const input = form.querySelector('[data-cp-search-input]');
    const list = form.querySelector('[data-cp-search-list]');
    if (!input || !list) return;
    let results = [], active = -1;

    const close = () => {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    };

    const pick = r => {
      if (!r || !r.v.available) return;
      choose(r);
      input.value = r.m;
      close();
      input.blur();
    };

    const search = q => {
      const n = norm(q);
      if (!n) return [];
      const toks = n.split(' ');
      const compact = n.replace(/ /g, '');
      const out = [];
      index.forEach((r, i) => {
        if (!(toks.every(t => r.h.includes(t)) || r.c.includes(compact))) return;
        let s = 0;
        if (r.mn === n) s += 6;
        if (r.mn.startsWith(n)) s += 3;
        if (norm(r.b).startsWith(toks[0])) s += 1;
        if (!r.v.available) s -= 10;
        out.push([s, i, r]);
      });
      out.sort((a, b) => (b[0] - a[0]) || (a[1] - b[1]));
      return out.slice(0, 8).map(x => x[2]);
    };

    const render = () => {
      list.replaceChildren();
      if (!results.length) {
        const li = document.createElement('li');
        li.className = 'cp-search__empty';
        li.textContent = 'No match found. Check the spelling or choose your brand below.';
        list.append(li);
      } else {
        results.forEach((r, i) => {
          const li = document.createElement('li');
          li.id = list.id + '-' + i;
          li.setAttribute('role', 'option');
          li.setAttribute('aria-selected', String(i === active));
          li.className = 'cp-search__opt' + (i === active ? ' is-active' : '') + (r.v.available ? '' : ' is-soldout');
          const m = document.createElement('span');
          m.className = 'cp-search__model';
          m.textContent = r.m;
          const b = document.createElement('span');
          b.className = 'cp-search__brand';
          b.textContent = r.v.available ? r.b : r.b + ' \u00b7 Sold out';
          li.append(m, b);
          li.addEventListener('mousedown', e => { e.preventDefault(); pick(r); });
          list.append(li);
        });
      }
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (active >= 0) input.setAttribute('aria-activedescendant', list.id + '-' + active);
      else input.removeAttribute('aria-activedescendant');
    };

    input.addEventListener('input', () => {
      if (!norm(input.value)) { results = []; close(); return; }
      results = search(input.value);
      active = results.length ? 0 : -1;
      render();
    });
    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); if (!list.hidden && results[active]) pick(results[active]); return; }
      if (list.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); active = Math.min(results.length - 1, active + 1); render(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); active = Math.max(0, active - 1); render(); }
      else if (e.key === 'Escape') { close(); }
    });
    input.addEventListener('focus', () => { if (results.length && norm(input.value)) render(); });
    input.addEventListener('blur', () => setTimeout(close, 150));

    // If the shopper picks with the dropdowns instead, show that model in the search bar.
    modelSel && modelSel.addEventListener('change', () => {
      if (document.activeElement === input) return;
      const r = index.find(x => String(x.v.id) === modelSel.value);
      input.value = r ? r.m : '';
    });
    brandSel && brandSel.addEventListener('change', () => {
      if (document.activeElement !== input) input.value = '';
    });
  }

  const init = (scope = document) => scope.querySelectorAll('[data-cp-picker]').forEach(setup);
  const later = () => setTimeout(() => init(), 0);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later);
  else later();
  document.addEventListener('shopify:section:load', e => setTimeout(() => init(e.target), 0));
})();
